import React, { useEffect, useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={isScrolled ? 'scrolled' : ''}>
      <div className="container">
        <nav className="navbar">
          <a href="#inicio" className="logo">
            <span className="logo-icon"><i className="fas fa-syringe"></i></span>
            Agro<span>Vacina</span>
          </a>
          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li className="nav-item"><a href="#inicio" className="nav-link" onClick={closeMenu}>Início</a></li>
            <li className="nav-item"><a href="#video-mvp" className="nav-link" onClick={closeMenu}>MVP</a></li>
            <li className="nav-item"><a href="#conquista" className="nav-link nav-link-highlight" onClick={closeMenu}><i className="fas fa-trophy"></i> Conquista</a></li>
            <li className="nav-item"><a href="#problema" className="nav-link" onClick={closeMenu}>Problema</a></li>
            <li className="nav-item"><a href="#solucao" className="nav-link" onClick={closeMenu}>Solução</a></li>
            <li className="nav-item"><a href="#planos" className="nav-link" onClick={closeMenu}>Planos</a></li>
            <li className="nav-item"><a href="#galeria" className="nav-link" onClick={closeMenu}>Galeria</a></li>
            <li className="nav-item"><a href="#equipe" className="nav-link" onClick={closeMenu}>Equipe</a></li>
            <li className="nav-item"><a href="#contato" className="nav-link" onClick={closeMenu}>Contato</a></li>
          </ul>
          <a href="#contato" className="btn nav-cta" onClick={closeMenu}>Fale Conosco</a>
          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
